import { Component, ElementRef, EventEmitter, Input, NgZone, Output } from "@angular/core";
import ResizeObserver from "resize-observer-polyfill";
import { ITile } from "../../../shared/models/tile.model";
@Component({
  selector: "au-tile",
  templateUrl: "./tile.component.html",
  styleUrls: ["./tile.component.scss"],

})
export class TileComponent {
  @Output() onClick = new EventEmitter<ITile>();
  @Input() tile: ITile = {
    name: "",
    key: "",
    picture: "",
    defaultImageClass: "",
    defaultImage: ""
  };
  imageSize = 80;
  observer: ResizeObserver;

  constructor(
    private host: ElementRef,
    private zone: NgZone
  ) {
    this.observer = new ResizeObserver(entries => {
      this.zone.run(() => {
        this.imageSize = entries[0].contentRect.width * 0.5;
        this.host.nativeElement.style.setProperty("--width-px", entries[0].contentRect.width + "px");
        this.host.nativeElement.style.setProperty("--tile-image-size", this.imageSize + "px");
      });
    });

  }

  ngOnInit() {
    this.observer.observe(this.host.nativeElement);
  }

  ngOnDestroy() {
    this.observer.unobserve(this.host.nativeElement);
  }


  onTileClick(): void {
    this.onClick.emit(this.tile);
  }
}
